export enum JournalChangeItem {
  /**
   * 充值
   */
  RECHARGE = 0,
  /**
   * 提现
   */
  WITHDRAW = 1,
  /**
   * 保证金
   */
  BAIL = 2,
  /**
   * 入场费
   */
  ENTRANCE = 3,
  /**
   * 服务费
   */
  SERVICE = 4,
  /**
   * 违约
   */
  RENEGE = 5,
  /**
   * 车辆服务
   */
  VEHICLE = 6,
  /**
   * 环保保证金
   */
  ENVIRONMENT = 7
}

export const JournalChangeItemMap: Record<JournalChangeItem, string> = {
  [JournalChangeItem.RECHARGE]: '充值',
  [JournalChangeItem.WITHDRAW]: '提现',
  [JournalChangeItem.BAIL]: '保证金',
  [JournalChangeItem.ENTRANCE]: '入场费',
  [JournalChangeItem.SERVICE]: '服务费',
  [JournalChangeItem.RENEGE]: '违约',
  [JournalChangeItem.VEHICLE]: '车辆服务',
  [JournalChangeItem.ENVIRONMENT]: '环保保证金'
}

export const JournalChangeItemKeyMap: Record<JournalChangeItem, string> = {
  [JournalChangeItem.RECHARGE]: 'rechargeAmount',
  [JournalChangeItem.WITHDRAW]: 'withdrawAmount',
  [JournalChangeItem.BAIL]: 'bailAmount',
  [JournalChangeItem.ENTRANCE]: 'entranceAmount',
  [JournalChangeItem.SERVICE]: 'serviceAmount',
  [JournalChangeItem.RENEGE]: 'renegeAmount',
  [JournalChangeItem.VEHICLE]: 'vehicleAmount',
  [JournalChangeItem.ENVIRONMENT]: 'environmentAmount'
}
